//
// アンケートフォーム画面
//

// NOTE: DOMContentLoadedではブラウザバック時に反応できないためpageshowを使用
window.addEventListener('pageshow', (element) => {
  const pages = document.querySelectorAll('.survey-page')
  if (pages.length == 0) return;

  const select = document.getElementsByClassName('form-select')

  for(const el of select) {
    el.addEventListener('change', ev => {
      if(ev.target.value === '') {
        ev.target.classList.add("is-blank")
      } else {
        ev.target.classList.remove("is-blank")
      }
    })
  }

  const requiredElements = document.querySelectorAll('[required]')
  const submit = document.querySelector('input[type="submit"]')
  const checkRequiredInput = () => {
    let disabled = false
    for(const el of requiredElements) {
      if(el.value === '') disabled = true
    }
    submit.disabled = disabled
  }

  for(const el of requiredElements) {
    el.addEventListener('change', ev => {
      checkRequiredInput()
    })
  }
  checkRequiredInput()
})
